import React, { useState, useEffect, ReactElement } from "react";
import { useParams } from 'react-router-dom';
import { useForm, Controller, FormProvider } from "react-hook-form";
import { Alert, NotificationHub, FormField, Button } from "@nef/core";
import { useDispatch } from "react-redux";

import { GUID_REGEX, EMAIL_REGEX } from "../../constants/regexRepo";
import { OrganizationStageModel } from "../../generated/api";
import StyledInformationCollection from "../../styles/InformationCollection.styles";
import AddIssuerUi from "../../CommonComponents/AddIssuerUi";
import { checkOrgStageHasPendingIssuerStages, editOrgStage, fetchOrgStageByOrgStageId, submitOrganizationStagesByOrgId } from "../../redux/organizationStages/actions";
import { AppDispatch } from "../../app/store";


const NewAffiliates = (props: any) => {
  const { id }: { id: string } = useParams();
  const [renderForm, setRenderForm] = useState(false);
  const dispatch = useDispatch<AppDispatch>();
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [organizationStage, setOrganizationstage] = useState<OrganizationStageModel>();
  const [renderAlert, setRenderAlert] = useState<ReactElement | undefined>();

  const methods = useForm({
    mode: "onChange",
    defaultValues: {
      firstName: "",
      lastName: "",
      email: "",
      title: "",
      issuers: []
    }
  });

  const { control, handleSubmit, formState: { isValid } } = useForm({
    mode: "onChange",
    defaultValues: {
      firstName: "",
      lastName: "",
      email: "",
      title: "",
      issuers: []
    }
  });

  useEffect(() => {
    renderUserMessage();
  }, [id]);

  const renderUserMessage = () => {
    if (!id || !id.match(GUID_REGEX)) {
      setRenderAlert(
        <div className="new-affiliates__alert">
          <Alert color="warning">
            <span>This page is for Officer of the fund of the existing approved organization to add additional affiliates.
              Please follow the <a href="../register">link</a> to fill up application for new Organization.  If your organization already registered please contact NFN operations
            </span>
          </Alert>
        </div>
      );
      setRenderForm(false);
    }
    else {
      dispatch(checkOrgStageHasPendingIssuerStages(id)).unwrap()
        .then((res) => {

          if (res === true) {
            setRenderAlert(
              <div className="new-affiliates__alert">
                <Alert color="warning">
                  <span>Your Affiliates being reviewed, if you need submit additional affiliates please contact NFN operations</span>
                </Alert>
              </div>
            );
            setRenderForm(false);

          } else {

            dispatch(fetchOrgStageByOrgStageId(id)).unwrap()
              .then(response => {
                const orgStage = response;
                setOrganizationstage(orgStage);
              })

            setRenderForm(true);
          }
        })
        .catch(error => {
          setRenderAlert(
            <div className="new-affiliates__alert">
              <Alert color="warning">
                <span>{error.message}</span>
              </Alert>
            </div>
          );
          setRenderForm(false);
        });
    }
  }

  const onSubmit = async (data: any) => {
    const { getValues } = methods;
    const issuers = getValues("issuers");

    if (organizationStage?.organizationStageId && issuers && issuers.length > 0) {
      organizationStage.signatoryEmail = data.email;
      organizationStage.signatoryFirstName = data.firstName;
      organizationStage.signatoryLastName = data.lastName;
      organizationStage.signatoryTitle = data.title;
      setIsLoading(true);
      try {
        const response = await dispatch(editOrgStage({ organizationStageId: id, payload: organizationStage })).unwrap()
        if (response) {
          const payload: any[] = [];
          issuers.forEach((_issuer: any) => {
            const issuerData: any = {
              organizationStageId: response?.organizationStageId,
              firstCreatedDate: new Date(),
              firstCreatedBy: data.email,
              issuerName: _issuer?.issuerName
            }
            if (_issuer.identifier?.length === 12) {
              issuerData.isin = _issuer.identifier;
            }
            else if (_issuer.identifier?.length === 9) {
              issuerData.cusip = _issuer.identifier;
            }
            else {
              issuerData.cusip = ""
              issuerData.isin = ""
            }
            payload.push(issuerData);
          })

          try {
            const res = await dispatch(submitOrganizationStagesByOrgId({
              organizationStageId: response?.organizationStageId,
              payload
            })).unwrap();
            if (res?.length) {
              NotificationHub.send("success", "Issuers created!", {
                position: "top-right"
              });
            }
          }
          catch (err: any) {
            if (err.error && err.error.errors) {
              const errormsg = err.error.errors;
              setErrorMessage(convertErrors(errormsg))
            }
            NotificationHub.send("danger", "Issuer creation failed!", {
              position: "top-right"
            });
          }
          finally {
            setIsLoading(false);
          }
        }
      }
      catch (err: any) {
        NotificationHub.send("danger", `${err?.message}`);
      }
      finally {
        setIsLoading(false);
      }
    }
    else {
      NotificationHub.send("danger", "Please add an issuer!");
    }
  }

  /* eslint-disable no-restricted-syntax */
  const convertErrors = (errorObject: any) => {
    let errMsg = '';
    for (const [key, value] of Object.entries(errorObject)) {
      const position = key[1]; // Extracts the position from the key
      errMsg += `For issuer ${+position + 1}: ${(value as string)[0]}\n`;
    }
    return errMsg;
  }

  return (
    <>
      {renderAlert}
      {
        renderForm ?
          <FormProvider {...methods}>
            <form className="new-affiliates__form">
              <StyledInformationCollection className="information-collection">
                <div className="new-affiliates__header">
                  {organizationStage?.organizationName}
                </div>
                <Controller
                  name="firstName"
                  control={control}
                  rules={{ required: true, minLength: 1 }}
                  render={({ field: { onChange, value, name }, fieldState, formState }) => (
                    <FormField
                      className="form-field"
                      label="First Name"
                      name={name}
                      value={value}
                      invalid={fieldState.error != null}
                      feedback={fieldState.error?.message}
                      onChange={onChange}
                    />
                  )}
                />
                <Controller
                  name="lastName"
                  control={control}
                  rules={{ required: true, minLength: 1 }}
                  render={({ field: { onChange, value, name }, fieldState, formState }) => (
                    <FormField
                      className="form-field"
                      label="Last Name"
                      name={name}
                      value={value}
                      invalid={fieldState.error != null}
                      feedback={fieldState.error?.message}
                      onChange={onChange}
                    />
                  )}
                />
                <Controller
                  name="title"
                  control={control}
                  rules={{ required: true, minLength: 1 }}
                  render={({ field: { onChange, value, name }, fieldState, formState }) => (
                    <FormField
                      className="form-field"
                      label="Title"
                      name={name}
                      value={value}
                      invalid={fieldState.error != null}
                      feedback={fieldState.error?.message}
                      onChange={onChange}
                    />
                  )}
                />
                <Controller
                  name="email"
                  control={control}
                  rules={{
                    required: true,
                    // eslint-disable-next-line  no-control-regex
                    pattern: { value: EMAIL_REGEX, message: "Invalid Email Format" },
                    minLength: { value: 6, message: "minimum email length should be atleast 6 characters " }
                  }
                  }
                  render={({ field: { onChange, value, name }, fieldState, formState }) => (
                    <FormField
                      className="form-field"
                      label="Email"
                      name={name}
                      value={value}
                      invalid={fieldState.error != null}
                      feedback={fieldState.error?.message}
                      onChange={onChange}
                    />
                  )}
                />
                <AddIssuerUi issuerName="" />
                <Button onClick={handleSubmit(onSubmit)} isLoading={isLoading}>Submit</Button>
              </StyledInformationCollection >
            </form>
          </FormProvider>
          : <></>
      }
      {
        errorMessage && <div className="add-issuer__error-msg">
          {
            errorMessage.split('\n').map((line) =>
              <span key={line}>
                {line}
                <br />
              </span>
            )
          }
        </div>
      }
      <NotificationHub />
    </>
  );
};
export default NewAffiliates;
